export default __webpack_public_path__ + "26eeb28a1fe129602da60e721639ab4e.svg";